import BlogCard from './Card';

export default BlogCard;
